import * as R from 'remeda';
import { Survey } from '@rossum/api-client/surveys';
import {
  hasUserAnsweredSurveyBlocker,
  isBeforeInterval,
  isUserAnnoyedBlocker,
  userNotEngagedBlocker,
} from '../blockers';

export const getDiscoveryCallSurveyBlockersFromSurvey = ({
  survey,
  userEngaged,
}: {
  survey: Survey;
  userEngaged: boolean;
}) =>
  [
    hasUserAnsweredSurveyBlocker(survey),
    isUserAnnoyedBlocker(survey, 2),
    userNotEngagedBlocker(userEngaged),
    isBeforeInterval(),
  ].filter(R.isTruthy);
